import { render } from "./page6.vue?vue&type=template&id=75cebc72&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"

import "./page6.vue?vue&type=style&index=0&id=75cebc72&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cebc72"]])

export default __exports__